import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {getCurrentAction, getLevel} from "../selectors";
import {sessionSelectInputMutation} from "../graphql";
import {isAnyUserInputAction} from "../utils";
import {EducationSessionPassedResult, MutationEducationSessionSelectInputArgs} from "../../../schema";
import {analyticsSendEvent} from "../../../libs/analytics";
import {isMultipleChoiceUserInputAction, WithoutTypename} from "../../../types";
import handleUserAnswerResult from "../actionHandlers/handleUserAnswerResult";
import multipleSelectInput from "./multipleSelectInput";

export default function selectInput(index: number) {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();
    const action = getCurrentAction(state);

    if (isMultipleChoiceUserInputAction(action)) {
      dispatch(multipleSelectInput(index));
      return;
    }

    if (!action || !isAnyUserInputAction(action)) {
      console.warn("passUserInput: wrong action");
      return;
    }

    analyticsSendEvent("playerSelectChoiceBranchAction", {
      sessionId: state.sessionId!,
      level: getLevel(state),
      actionId: action.id,
      actionType: action.__typename,
    });

    state.client
      .mutate<
        {
          result: WithoutTypename<EducationSessionPassedResult>;
        },
        MutationEducationSessionSelectInputArgs
      >({
        mutation: sessionSelectInputMutation,
        variables: {
          sessionId: state.sessionId!,
          level: getLevel(state),
          actionId: action.id,
          index: index,
        },
      })
      .then((mutationResult) => {
        if (!mutationResult.data) {
          console.error("passUserInput: invalid mutation result");
          dispatch({
            type: "update",
            payload: {isRecognizing: false},
          });
          return;
        }

        const result = mutationResult.data.result;

        handleUserAnswerResult({result, state, dispatch, action, challengeMode: state.challenge.mode});
      })
      .catch((err) => {
        dispatch({
          type: "update",
          payload: {isRecognizing: false},
        });

        console.error(err);
      });
  };
}
